var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevopicLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 935",
    style: {
      enableBackground: "new 0 0 1000 935"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#1D1D1B",
    d: "M27.5,932.9H0V773.4h54c18.8,0,32.7,6.7,41.9,20.2c5.7,8.2,8.6,17.4,8.6,27.7c0,14.5-5.1,26.3-15.2,35.4   c-3.3,3.1-7.1,5.6-11.3,7.5l31.3,68.6H77.6l-26.7-63.6H27.5L27.5,932.9L27.5,932.9z M27.5,796.7v49.2H54c9.4,0,16-4.4,19.8-13.1   c1.7-3.8,2.5-7.6,2.5-11.7c0-9.2-3.2-16-9.6-20.6c-3.8-2.5-8-3.8-12.7-3.8L27.5,796.7L27.5,796.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#1D1D1B",
    d: "M193.2,864.7v44.8h70.5v23.3h-98V773.4h95.9v23.3h-68.4v44.8h59.6v23.1h-59.6V864.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#1D1D1B",
    d: "M371.6,908.9c2.8-18.8,9.2-51.8,19.4-99c3.1-14.5,5.6-26.6,7.5-36.5h29.8L392,932.9h-40.4l-36.3-159.5h29.6   l25.9,124.7L371.6,908.9L371.6,908.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#1D1D1B",
    d: "M480,888.3V818c0-15.4,6.3-27.6,19-36.5c9.7-6.8,21.1-10.2,34.2-10.2c17,0,30.6,5.3,40.9,15.8   c8.3,8.5,12.5,18.8,12.5,30.8v70.3c0,15.4-6.3,27.6-19,36.5c-9.7,6.8-21.2,10.2-34.4,10.2c-17.1,0-30.7-5.3-40.9-15.8   C484.1,910.5,480,900.2,480,888.3L480,888.3z M559,888.3V818c0-8.2-3.7-14.6-11.1-19.2c-4.4-2.9-9.4-4.4-14.8-4.4   c-9.2,0-16.3,3.5-21.3,10.4c-2.9,4-4.4,8.4-4.4,13.1v70.3c0,8.2,3.7,14.7,11,19.4c4.5,2.8,9.3,4.2,14.6,4.2   c9.3,0,16.5-3.5,21.5-10.6C557.5,897.1,559,892.8,559,888.3L559,888.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#1D1D1B",
    d: "M647.8,932.9V773.4h54c18.8,0,32.9,7.1,42.3,21.3c5.8,8.9,8.8,18.9,8.8,30c0,15.4-5.1,28-15.2,37.7   c-9.3,8.9-21.3,13.3-35.9,13.3h-26.5v57.1L647.8,932.9L647.8,932.9z M675.3,796.7v55.7h26.5c9.4,0,16.2-4.7,20.2-14.2   c1.8-4.3,2.7-8.9,2.7-13.8c0-10.4-3.3-18.2-9.8-23.3c-3.9-2.9-8.3-4.4-13.1-4.4H675.3L675.3,796.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#1D1D1B",
    d: "M810.3,773.4h27.5v159.5h-27.5V773.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#1D1D1B",
    d: "M1000,888.3c0,15.6-6.1,27.8-18.4,36.7c-9.3,6.7-20.2,10-32.7,10c-16.3,0-29.3-5.3-39.2-15.8   c-7.9-8.6-11.9-18.9-11.9-30.8V818c0-15.6,6.1-27.8,18.4-36.7c9.3-6.7,20.2-10,32.7-10c16.3,0,29.3,5.3,39.2,15.8   c7.9,8.6,11.9,18.9,11.9,30.8h-27.5c0-8.2-3.4-14.7-10.2-19.4c-4.2-2.8-8.6-4.2-13.3-4.2c-8.2,0-14.7,3.4-19.4,10.2   c-2.8,4.2-4.2,8.6-4.2,13.3v70.3c0,8.2,3.4,14.7,10.2,19.4c4.2,2.8,8.6,4.2,13.3,4.2c8.2,0,14.7-3.4,19.4-10.2   c2.8-4.2,4.2-8.6,4.2-13.3h27.5V888.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#1D1D1B",
    d: "M421.7,439.3c117.9,25.5,230.6-44.2,250.4-160.2c16.4-95.8-50.8-189.8-147.9-209.9c-110.4-22.8-218,53.3-233.4,165.4   c-1.9,13.7-1.1,27.7-1.1,41.6c0,123.2,0.1,246.4,0.2,369.7c0,4.3,0,8.5,0,13.8h-67.3c-0.2-2.9-0.6-5.8-0.6-8.7   c0.1-127.6,0.5-255.1,0.1-382.7c-0.3-69.3,20.4-130.6,67.5-181.7c88.5-96.2,230.8-114.3,338.5-44c132.1,86.2,152,271.9,40.7,383.8   c-14.6,14.7-31.1,27.4-47.2,41.6c50.8,62.5,102.7,126.3,156.6,192.7c-13.7,0.5-21.6,0.3-38,0.3c-36.2,0-53.6-7.3-73-34.2   c-31.1-43.2-67-82.9-101.3-123.8c-3.1-3.7-10.3-7.3-14.3-6.3c-39.1,10.2-78.6,12.6-118.6,7.6c-2.5-0.3-8.2-1.1-12.5-1.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.07,
    y1: 378.3774,
    x2: 566.4102,
    y2: 88.7674,
    gradientTransform: "matrix(1 0 0 1 0 139.9578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#25A963",
      stopOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#42B3E7",
      stopOpacity: 0.65
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "url(#SVGID_1_)",
    d: "M352.9,661.3c0-11.7,0-22.5,0-33.3c0-123.6,0-247.3-0.1-370.9c0-47.2,20.6-83.3,61.9-105.1   c41.8-22.1,85.1-22.6,126.3,2.7c39.4,24.2,60.4,72.4,52.6,117.8c-8,46.6-42.5,84.6-88.4,92.8c-21.5,3.8-38.3,4.1-49.6,3.8   c-11.3-0.3-26-1.8-32.2-1.8v294H352.9L352.9,661.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevopicLogoColor);
export default __webpack_public_path__ + "static/media/revopic-logo-color.d47e732579a9b567278e76bf7ac0335f.svg";
export { ForwardRef as ReactComponent };